import { Column, ColumnInformation } from '../../../../../types'

/**
 * Calculates the cumulative width up to a given index in an array of column widths.
 */
export const getCumulativeWidth = (index: number, widths: ColumnInformation[]): number => {
    if (!widths?.length || index === 0) return 0

    let cumulativeWidth = 0

    // Iterate through the widths array up to the specified index and accumulate the widths.
    for (let i = 0; i < index; i++) {
        cumulativeWidth += widths[i].width
    }

    return cumulativeWidth
}

export const getStickyLeftPosition = (column: Column, allColumns: Column[], columnWidths: ColumnInformation[]) => {
    const columnIndex = allColumns.findIndex((col) => col === column)

    return `${getCumulativeWidth(columnIndex, columnWidths?.filter((it) => it.position === 'left') ?? [])}px`
}

export const getStickyRightPosition = (column: Column, allColumns: Column[], columnWidths: ColumnInformation[]) => {
    //We reverse the columns because we are working from right to left
    const reversedInfo = columnWidths?.slice().reverse()
    const right = reversedInfo?.filter((it) => it.position === 'right')

    if (right?.length) {
        const reversedColumns = allColumns?.slice().reverse()
        const columnIndex = reversedColumns.findIndex((col) => col === column)
        return `${getCumulativeWidth(columnIndex, right)}px`
    }
    return null
}
